module.exports = __webpack_public_path__ + "assets/img/480b-as.svg";